// ============================================================================
// LA PASTILLE MÉTÉO — le disque qui porte l'icône du temps, teinté par ce temps-là.
//
// ⚠️ EXTRAITE PLUTÔT QUE RECOPIÉE (2026-09-05). Elle vivait dans l'écran du tableau de bord ; la
// planche de charte avait besoin de la MONTRER. La recopier aurait fait exactement le défaut que la
// planche est censée dénoncer : une charte qui présente un dessin ressemblant au vrai, et qui cesse
// un jour de lui ressembler sans que personne le voie.
//
// ⚠️ LE COMPOSANT NE CHOISIT AUCUNE COULEUR. Il reçoit un temps, la charte lui rend un ton
// (`WEATHER_TONES`), il le pose. C'est ce qui permet de repeindre la météo de toutes les surfaces
// depuis un seul fichier de jetons.
// ============================================================================
import { ICONS, WEATHER_TONES, weatherTone, type IconName } from '@orgazone/ui-tokens';
import { Icon } from './icons';

export interface WeatherPillProps {
  /**
   * Le temps tel que le service le nomme (`clear`, `snow`, `storm`…).
   * ⚠️ `null` quand la météo n'a pas pu être lue : la pastille prend alors le ton neutre. Peindre un
   * temps inconnu en ambre annoncerait du soleil.
   */
  kind: string | null;
  /** Le nom d'icône déjà résolu par l'appelant — la correspondance temps → dessin lui appartient. */
  icon: IconName;
  size?: number;
}

/** Le disque teinté qui porte l'icône du temps. */
export function WeatherPill({ kind, icon, size = 52 }: WeatherPillProps) {
  const ton = WEATHER_TONES[weatherTone(kind)];
  return (
    <span style={{
      width: size, height: size, borderRadius: 'var(--r-pill)', flexShrink: 0,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      // ⚠️ LE MÊME DÉGRADÉ POUR TOUS LES TONS, seule la teinte change. L'écran peignait le soleil en
      // dégradé et le reste en aplat : la différence de TRAITEMENT se lisait avant la couleur, et
      // deux tuiles voisines semblaient de deux familles.
      background: `radial-gradient(circle at 50% 40%, var(--${ton.bg}), var(--paper) 78%)`,
      color: `var(--${ton.fg})`,
      boxShadow: `inset 0 0 0 1px var(--${ton.ring})`,
    }}>
      <Icon name={icon in ICONS ? icon : 'cloud'} size={Math.round(size * 0.54)} stroke={1.75} />
    </span>
  );
}
